import $ from "jquery";

(function ($) {

    $('.section-gallery').each(function () {

        $('a.section-gallery__item').colorbox({

            transition: 'fade',
            current: '({current} / {total})',

            slideshow: false,

            maxHeight: '95%',
            maxWidth: '95%',

            rel: function () {
                return $(this).attr('rel');
            },


            onComplete: function () {

                const img =
                    $('#cboxLoadedContent img')[0];

                if (!img) return;

            },


            onClosed: function () {

                $('.gallery-zoom-hint')
                    .remove();

            }

        });

    });

})(jQuery);